module.exports = __webpack_public_path__ + "static/media/10-8.f0f29944.mp3";